import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Reports = () => {
  const [stats, setStats] = useState(null);
  const [dailyReport, setDailyReport] = useState(null);
  const [transfersReport, setTransfersReport] = useState(null);
  const [exchangesReport, setExchangesReport] = useState(null);
  const [customerReport, setCustomerReport] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [transferPeriod, setTransferPeriod] = useState('daily');
  const [exchangePeriod, setExchangePeriod] = useState('daily');
  const [loadingPDF, setLoadingPDF] = useState('');
  const [activeTab, setActiveTab] = useState('overview');
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    fetchStats();
    fetchCustomers();
    fetchDailyReport(selectedDate);
  }, []);

  const fetchStats = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/reports/stats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchCustomers = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(res.data.customers);
    } catch (err) { console.error(err); }
  };

  const fetchDailyReport = async (date) => {
    try {
      const res = await axios.get(`https://app.hayahost.net/api/reports/daily?date=${date}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDailyReport(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchTransfersReport = async () => {
    try {
      let url = `https://app.hayahost.net/api/reports/transfers?period=${transferPeriod}`;
      if (transferPeriod === 'custom') url = `https://app.hayahost.net/api/reports/transfers?from_date=${fromDate}&to_date=${toDate}`;
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setTransfersReport(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchExchangesReport = async () => {
    try {
      let url = `https://app.hayahost.net/api/reports/exchanges?period=${exchangePeriod}`;
      if (exchangePeriod === 'custom') url = `https://app.hayahost.net/api/reports/exchanges?from_date=${fromDate}&to_date=${toDate}`;
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setExchangesReport(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchCustomerReport = async () => {
    if (!selectedCustomer) return alert('اختر عميلاً أولاً');
    try {
      let url = `https://app.hayahost.net/api/reports/customer/${selectedCustomer}`;
      if (fromDate && toDate) url += `?from_date=${fromDate}&to_date=${toDate}`;
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setCustomerReport(res.data);
    } catch (err) { console.error(err); }
  };

  const downloadPDF = async (type, params = {}) => {
    setLoadingPDF(type);
    try {
      let url = '';
      let filename = '';
      if (type === 'daily') {
        url = `https://app.hayahost.net/api/pdf/daily-report?date=${selectedDate}`;
        filename = `daily_report_${selectedDate}.pdf`;
      } else if (type === 'transfers') {
        let period = transferPeriod;
        url = `https://app.hayahost.net/api/pdf/transfers-report?period=${period}`;
        if (period === 'custom') url = `https://app.hayahost.net/api/pdf/transfers-report?from_date=${fromDate}&to_date=${toDate}`;
        filename = `transfers_report.pdf`;
      } else if (type === 'exchanges') {
        let period = exchangePeriod;
        url = `https://app.hayahost.net/api/pdf/exchanges-report?period=${period}`;
        if (period === 'custom') url = `https://app.hayahost.net/api/pdf/exchanges-report?from_date=${fromDate}&to_date=${toDate}`;
        filename = `exchanges_report.pdf`;
      } else if (type === 'customer') {
        url = `https://app.hayahost.net/api/pdf/customer-report/${selectedCustomer}`;
        if (fromDate && toDate) url += `?from_date=${fromDate}&to_date=${toDate}`;
        filename = `customer_report.pdf`;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const urlObj = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlObj;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) { alert('خطأ في تحميل PDF'); }
    setLoadingPDF('');
  };

  const handlePrint = () => { window.print(); };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const getStatusText = (status) => {
    switch(status) {
      case 'completed': return '✅ مكتملة';
      case 'pending': return '⏳ معلقة';
      case 'cancelled': return '❌ ملغاة';
      default: return status;
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.navbar} className="no-print">
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar} className="no-print">
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>📊 التقارير</a>
        </div>

        <div style={styles.content}>
          <style>{`@media print { .no-print { display: none !important; } body { direction: rtl; } }`}</style>

          <div style={styles.header} className="no-print">
            <h2 style={styles.pageTitle}>📊 التقارير والإحصائيات</h2>
            <div style={styles.reportInfo}>
              <span style={styles.reportUser}>👤 {user.username || 'المستخدم'}</span>
              <span style={styles.reportDate}>📅 {new Date().toLocaleDateString('ar-IQ')}</span>
              <button style={styles.printBtn} onClick={handlePrint}>🖨️ طباعة</button>
            </div>
          </div>

          {/* تبويبات */}
          <div style={styles.tabs} className="no-print">
            {[
              { key: 'overview', label: '📊 نظرة عامة' },
              { key: 'daily', label: '📅 يومي' },
              { key: 'transfers', label: '💸 الحوالات' },
              { key: 'exchanges', label: '💱 الصرافة' },
              { key: 'customer', label: '👤 تقرير عميل/شركة' },
            ].map(tab => (
              <button key={tab.key}
                style={activeTab === tab.key ? styles.tabActive : styles.tabBtn}
                onClick={() => setActiveTab(tab.key)}>
                {tab.label}
              </button>
            ))}
          </div>

          {/* === نظرة عامة === */}
          {activeTab === 'overview' && stats && (
            <>
              <div style={styles.statsGrid}>
                <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
                  <div style={styles.statIcon}>👥</div>
                  <div style={styles.statNumber}>{stats.customers}</div>
                  <div style={styles.statLabel}>إجمالي العملاء</div>
                </div>
                <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
                  <div style={styles.statIcon}>💸</div>
                  <div style={styles.statNumber}>{stats.transfers.count}</div>
                  <div style={styles.statLabel}>إجمالي الحوالات</div>
                </div>
                <div style={{...styles.statCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
                  <div style={styles.statIcon}>💱</div>
                  <div style={styles.statNumber}>{parseFloat(stats.exchanges.total_profit || 0).toFixed(0)}</div>
                  <div style={styles.statLabel}>إجمالي أرباح الصرف</div>
                </div>
                <div style={{...styles.statCard, background: 'linear-gradient(135deg, #880e4f, #c2185b)'}}>
                  <div style={styles.statIcon}>📋</div>
                  <div style={styles.statNumber}>{stats.pending_debts.count}</div>
                  <div style={styles.statLabel}>الديون المعلقة</div>
                </div>
              </div>
              <div style={styles.reportCard}>
                <h3 style={styles.reportTitle}>🏛️ أرصدة القاصة</h3>
                <div style={styles.treasuryGrid}>
                  {stats.treasury.map((t, i) => (
                    <div key={i} style={styles.treasuryItem}>
                      <span style={styles.tCurrency}>{t.currency_code}</span>
                      <span style={{...styles.tBalance, color: parseFloat(t.balance) >= 0 ? '#2e7d32' : '#c62828'}}>
                        {parseFloat(t.balance).toLocaleString()}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div style={styles.reportCard}>
                <h3 style={styles.reportTitle}>💸 ملخص عام</h3>
                <div style={styles.summaryGrid}>
                  <div style={styles.summaryItem}>
                    <span style={styles.summaryLabel}>إجمالي الحوالات</span>
                    <span style={styles.summaryValue}>{stats.transfers.count}</span>
                  </div>
                  <div style={styles.summaryItem}>
                    <span style={styles.summaryLabel}>إجمالي العمولات</span>
                    <span style={{...styles.summaryValue, color: '#e65100'}}>{parseFloat(stats.transfers.total_fees || 0).toFixed(2)}</span>
                  </div>
                  <div style={styles.summaryItem}>
                    <span style={styles.summaryLabel}>الديون المعلقة</span>
                    <span style={{...styles.summaryValue, color: '#c62828'}}>{stats.pending_debts.count}</span>
                  </div>
                  <div style={styles.summaryItem}>
                    <span style={styles.summaryLabel}>إجمالي الديون</span>
                    <span style={{...styles.summaryValue, color: '#c62828'}}>{parseFloat(stats.pending_debts.total || 0).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* === تقرير يومي === */}
          {activeTab === 'daily' && (
            <div style={styles.reportCard}>
              <div style={styles.reportHeader}>
                <h3 style={styles.reportTitle}>📅 التقرير اليومي</h3>
                <div style={styles.reportActions}>
                  <input style={styles.dateInput} type="date" value={selectedDate}
                    onChange={e => { setSelectedDate(e.target.value); fetchDailyReport(e.target.value); }} />
                  <button style={styles.pdfBtn} onClick={() => downloadPDF('daily')} disabled={loadingPDF === 'daily'}>
                    {loadingPDF === 'daily' ? '⏳...' : '📥 PDF'}
                  </button>
                  <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
                </div>
              </div>
              {dailyReport && (
                <div style={styles.dailyGrid}>
                  <div style={styles.dailyCard}>
                    <h4 style={styles.dailyTitle}>💸 الحوالات</h4>
                    <div style={styles.dailyStat}><span>عدد الحوالات</span><span style={styles.dailyValue}>{dailyReport.transfers.summary.total_count}</span></div>
                    <div style={styles.dailyStat}><span>إجمالي العمولات</span><span style={{...styles.dailyValue, color: '#e65100'}}>{parseFloat(dailyReport.transfers.summary.total_fees || 0).toFixed(2)}</span></div>
                  </div>
                  <div style={styles.dailyCard}>
                    <h4 style={styles.dailyTitle}>💱 الصرافة</h4>
                    <div style={styles.dailyStat}><span>إجمالي الأرباح</span><span style={{...styles.dailyValue, color: '#2e7d32'}}>{dailyReport.exchanges.total_profit}</span></div>
                  </div>
                  <div style={styles.dailyCard}>
                    <h4 style={styles.dailyTitle}>👥 العملاء الجدد</h4>
                    <div style={styles.dailyStat}><span>عدد العملاء الجدد</span><span style={styles.dailyValue}>{dailyReport.new_customers}</span></div>
                  </div>
                  <div style={styles.dailyCard}>
                    <h4 style={styles.dailyTitle}>⚠️ الديون المتأخرة</h4>
                    <div style={styles.dailyStat}><span>عدد الديون</span><span style={{...styles.dailyValue, color: '#c62828'}}>{dailyReport.overdue_debts.count}</span></div>
                    <div style={styles.dailyStat}><span>الإجمالي</span><span style={{...styles.dailyValue, color: '#c62828'}}>{parseFloat(dailyReport.overdue_debts.total || 0).toFixed(2)}</span></div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* === تقرير الحوالات === */}
          {activeTab === 'transfers' && (
            <div style={styles.reportCard}>
              <div style={styles.reportHeader}>
                <h3 style={styles.reportTitle}>💸 تقرير الحوالات</h3>
                <div style={styles.reportActions}>
                  {transfersReport && (
                    <>
                      <button style={styles.pdfBtn} onClick={() => downloadPDF('transfers')} disabled={loadingPDF === 'transfers'}>
                        {loadingPDF === 'transfers' ? '⏳...' : '📥 PDF'}
                      </button>
                      <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
                    </>
                  )}
                </div>
              </div>

              <div style={styles.periodRow}>
                {['daily', 'weekly', 'monthly', 'custom'].map(p => (
                  <button key={p} style={transferPeriod === p ? styles.periodActive : styles.periodBtn} onClick={() => setTransferPeriod(p)}>
                    {p === 'daily' ? '📅 يومي' : p === 'weekly' ? '📆 أسبوعي' : p === 'monthly' ? '🗓️ شهري' : '📊 مخصص'}
                  </button>
                ))}
              </div>

              {transferPeriod === 'custom' && (
                <div style={styles.dateRow}>
                  <div><label style={styles.filterLabel}>من تاريخ</label><input style={styles.dateInput} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} /></div>
                  <div><label style={styles.filterLabel}>إلى تاريخ</label><input style={styles.dateInput} type="date" value={toDate} onChange={e => setToDate(e.target.value)} /></div>
                </div>
              )}

              <button style={styles.fetchBtn} onClick={fetchTransfersReport}>🔍 إنشاء التقرير</button>

              {transfersReport && (
                <>
                  <div style={styles.summaryGrid}>
                    <div style={styles.summaryItem}><span style={styles.summaryLabel}>إجمالي الحوالات</span><span style={styles.summaryValue}>{transfersReport.summary.total_count}</span></div>
                    <div style={styles.summaryItem}><span style={styles.summaryLabel}>إجمالي العمولات</span><span style={{...styles.summaryValue, color: '#e65100'}}>{parseFloat(transfersReport.summary.total_fees || 0).toFixed(2)}</span></div>
                    <div style={styles.summaryItem}><span style={styles.summaryLabel}>✅ مكتملة</span><span style={{...styles.summaryValue, color: '#2e7d32'}}>{transfersReport.summary.completed}</span></div>
                    <div style={styles.summaryItem}><span style={styles.summaryLabel}>⏳ معلقة</span><span style={{...styles.summaryValue, color: '#e65100'}}>{transfersReport.summary.pending}</span></div>
                  </div>
                  <div style={styles.tableCard}>
                    <table style={styles.table}>
                      <thead><tr style={styles.tableHead}>
                        <th style={styles.th}>الرقم المرجعي</th><th style={styles.th}>المرسل</th><th style={styles.th}>المستلم</th>
                        <th style={styles.th}>المبلغ</th><th style={styles.th}>العمولة</th><th style={styles.th}>الحالة</th><th style={styles.th}>التاريخ</th>
                      </tr></thead>
                      <tbody>
                        {transfersReport.transfers.map((t, i) => (
                          <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                            <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{t.reference_number}</td>
                            <td style={styles.td}>{t.sender_name || 'عابر'}</td>
                            <td style={styles.td}>{t.receiver_name}</td>
                            <td style={styles.td}>{parseFloat(t.amount).toLocaleString()} {t.currency}</td>
                            <td style={{...styles.td, color: '#e65100'}}>{parseFloat(t.fee || 0).toFixed(2)}</td>
                            <td style={styles.td}>{getStatusText(t.status)}</td>
                            <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(t.created_at)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {transfersReport.transfers.length === 0 && <div style={styles.empty}>لا توجد بيانات</div>}
                  </div>
                </>
              )}
            </div>
          )}

          {/* === تقرير الصرافة === */}
          {activeTab === 'exchanges' && (
            <div style={styles.reportCard}>
              <div style={styles.reportHeader}>
                <h3 style={styles.reportTitle}>💱 تقرير الصرافة</h3>
                <div style={styles.reportActions}>
                  {exchangesReport && (
                    <>
                      <button style={styles.pdfBtn} onClick={() => downloadPDF('exchanges')} disabled={loadingPDF === 'exchanges'}>
                        {loadingPDF === 'exchanges' ? '⏳...' : '📥 PDF'}
                      </button>
                      <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
                    </>
                  )}
                </div>
              </div>

              <div style={styles.periodRow}>
                {['daily', 'weekly', 'monthly', 'custom'].map(p => (
                  <button key={p} style={exchangePeriod === p ? styles.periodActive : styles.periodBtn} onClick={() => setExchangePeriod(p)}>
                    {p === 'daily' ? '📅 يومي' : p === 'weekly' ? '📆 أسبوعي' : p === 'monthly' ? '🗓️ شهري' : '📊 مخصص'}
                  </button>
                ))}
              </div>

              {exchangePeriod === 'custom' && (
                <div style={styles.dateRow}>
                  <div><label style={styles.filterLabel}>من تاريخ</label><input style={styles.dateInput} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} /></div>
                  <div><label style={styles.filterLabel}>إلى تاريخ</label><input style={styles.dateInput} type="date" value={toDate} onChange={e => setToDate(e.target.value)} /></div>
                </div>
              )}

              <button style={styles.fetchBtn} onClick={fetchExchangesReport}>🔍 إنشاء التقرير</button>

              {exchangesReport && (
                <>
                  <div style={styles.summaryGrid}>
                    {exchangesReport.summary.map((s, i) => (
                      <div key={i} style={styles.summaryItem}>
                        <span style={styles.summaryLabel}>{s.from_currency} → {s.to_currency}</span>
                        <span style={{...styles.summaryValue, color: '#2e7d32', fontSize: '18px'}}>💰 {parseFloat(s.total_profit || 0).toLocaleString()}</span>
                        <span style={{fontSize: '12px', color: '#666'}}>{s.total_count} عملية</span>
                      </div>
                    ))}
                  </div>
                  <div style={styles.tableCard}>
                    <table style={styles.table}>
                      <thead><tr style={styles.tableHead}>
                        <th style={styles.th}>العميل</th><th style={styles.th}>من</th><th style={styles.th}>إلى</th>
                        <th style={styles.th}>المبلغ</th><th style={styles.th}>الربح</th><th style={styles.th}>التاريخ</th>
                      </tr></thead>
                      <tbody>
                        {exchangesReport.exchanges.map((e, i) => (
                          <tr key={e.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                            <td style={styles.td}>{e.customer_name || 'عابر'}</td>
                            <td style={styles.td}>{e.from_currency}</td>
                            <td style={styles.td}>{e.to_currency}</td>
                            <td style={styles.td}>{parseFloat(e.amount).toLocaleString()}</td>
                            <td style={{...styles.td, color: '#2e7d32', fontWeight: 'bold'}}>{parseFloat(e.profit || 0).toLocaleString()} {e.profit_currency}</td>
                            <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(e.created_at)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {exchangesReport.exchanges.length === 0 && <div style={styles.empty}>لا توجد بيانات</div>}
                  </div>
                </>
              )}
            </div>
          )}

          {/* === تقرير عميل/شركة === */}
          {activeTab === 'customer' && (
            <div style={styles.reportCard}>
              <div style={styles.reportHeader}>
                <h3 style={styles.reportTitle}>👤 تقرير عميل / شركة</h3>
                <div style={styles.reportActions}>
                  {customerReport && (
                    <>
                      <button style={styles.pdfBtn} onClick={() => downloadPDF('customer')} disabled={loadingPDF === 'customer'}>
                        {loadingPDF === 'customer' ? '⏳...' : '📥 PDF'}
                      </button>
                      <button style={styles.printBtn2} onClick={handlePrint}>🖨️ طباعة</button>
                    </>
                  )}
                </div>
              </div>

              <div style={styles.customerSelectRow}>
                <div style={{flex: 1}}>
                  <label style={styles.filterLabel}>اختر العميل أو الشركة</label>
                  <select style={styles.selectInput} value={selectedCustomer} onChange={e => setSelectedCustomer(e.target.value)}>
                    <option value="">-- اختر --</option>
                    {customers.map(c => (
                      <option key={c.id} value={c.id}>{c.customer_type === 'company' ? '🏢' : '👤'} {c.name} - {c.phone}</option>
                    ))}
                  </select>
                </div>
                <div><label style={styles.filterLabel}>من تاريخ</label><input style={styles.dateInput} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} /></div>
                <div><label style={styles.filterLabel}>إلى تاريخ</label><input style={styles.dateInput} type="date" value={toDate} onChange={e => setToDate(e.target.value)} /></div>
                <button style={styles.fetchBtn} onClick={fetchCustomerReport}>🔍 إنشاء التقرير</button>
              </div>

              {customerReport && (
                <>
                  <div style={styles.customerInfoCard}>
                    <div style={styles.customerInfoRow}>
                      <div>
                        <h3 style={styles.customerInfoName}>{customerReport.customer.customer_type === 'company' ? '🏢' : '👤'} {customerReport.customer.name}</h3>
                        <p style={styles.customerInfoDetail}>📞 {customerReport.customer.phone}</p>
                        {customerReport.customer.address && <p style={styles.customerInfoDetail}>📍 {customerReport.customer.address}</p>}
                      </div>
                      <div style={styles.customerSummaryBoxes}>
                        <div style={styles.summaryBox}><span style={styles.summaryBoxLabel}>💸 الحوالات</span><span style={styles.summaryBoxValue}>{customerReport.summary.total_transfers}</span></div>
                        <div style={styles.summaryBox}><span style={styles.summaryBoxLabel}>💱 الصرافة</span><span style={styles.summaryBoxValue}>{customerReport.summary.total_exchanges}</span></div>
                        <div style={styles.summaryBox}><span style={styles.summaryBoxLabel}>💰 العمولات</span><span style={{...styles.summaryBoxValue, color: '#e65100'}}>{parseFloat(customerReport.summary.total_fees || 0).toFixed(2)}</span></div>
                      </div>
                    </div>
                  </div>

                  {customerReport.accounts.length > 0 && (
                    <div style={styles.section}>
                      <h4 style={styles.sectionTitle}>💳 أرصدة الحسابات</h4>
                      <div style={styles.treasuryGrid}>
                        {customerReport.accounts.map((a, i) => (
                          <div key={i} style={styles.treasuryItem}>
                            <span style={styles.tCurrency}>{a.currency_code}</span>
                            <span style={{...styles.tBalance, color: parseFloat(a.balance) >= 0 ? '#2e7d32' : '#c62828', fontSize: '18px'}}>{parseFloat(a.balance).toLocaleString()}</span>
                            <div style={{fontSize: '11px', color: '#666', textAlign: 'center'}}>
                              <div>له: {parseFloat(a.total_credit).toLocaleString()}</div>
                              <div>عليه: {parseFloat(a.total_debit).toLocaleString()}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {customerReport.transfers.length > 0 && (
                    <div style={styles.section}>
                      <h4 style={styles.sectionTitle}>💸 الحوالات ({customerReport.transfers.length})</h4>
                      <div style={styles.tableCard}>
                        <table style={styles.table}>
                          <thead><tr style={styles.tableHead}><th style={styles.th}>الرقم المرجعي</th><th style={styles.th}>المستلم</th><th style={styles.th}>المبلغ</th><th style={styles.th}>العمولة</th><th style={styles.th}>الحالة</th><th style={styles.th}>التاريخ</th></tr></thead>
                          <tbody>
                            {customerReport.transfers.map((t, i) => (
                              <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                                <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{t.reference_number}</td>
                                <td style={styles.td}>{t.receiver_name}</td>
                                <td style={styles.td}>{parseFloat(t.amount).toLocaleString()} {t.currency}</td>
                                <td style={{...styles.td, color: '#e65100'}}>{parseFloat(t.fee || 0).toFixed(2)}</td>
                                <td style={styles.td}>{getStatusText(t.status)}</td>
                                <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(t.created_at)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {customerReport.exchanges.length > 0 && (
                    <div style={styles.section}>
                      <h4 style={styles.sectionTitle}>💱 عمليات الصرافة ({customerReport.exchanges.length})</h4>
                      <div style={styles.tableCard}>
                        <table style={styles.table}>
                          <thead><tr style={styles.tableHead}><th style={styles.th}>من</th><th style={styles.th}>إلى</th><th style={styles.th}>المبلغ</th><th style={styles.th}>الربح</th><th style={styles.th}>التاريخ</th></tr></thead>
                          <tbody>
                            {customerReport.exchanges.map((e, i) => (
                              <tr key={e.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                                <td style={styles.td}>{e.from_currency}</td><td style={styles.td}>{e.to_currency}</td>
                                <td style={styles.td}>{parseFloat(e.amount).toLocaleString()}</td>
                                <td style={{...styles.td, color: '#2e7d32', fontWeight: 'bold'}}>{parseFloat(e.profit || 0).toLocaleString()}</td>
                                <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(e.created_at)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {customerReport.debts.length > 0 && (
                    <div style={styles.section}>
                      <h4 style={styles.sectionTitle}>📋 المديونيات ({customerReport.debts.length})</h4>
                      <div style={styles.tableCard}>
                        <table style={styles.table}>
                          <thead><tr style={styles.tableHead}><th style={styles.th}>النوع</th><th style={styles.th}>المبلغ</th><th style={styles.th}>المتبقي</th><th style={styles.th}>العملة</th><th style={styles.th}>الحالة</th></tr></thead>
                          <tbody>
                            {customerReport.debts.map((d, i) => (
                              <tr key={d.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                                <td style={styles.td}>{d.debt_type === 'payable' ? '📤 علينا' : '📥 لنا'}</td>
                                <td style={styles.td}>{parseFloat(d.amount).toLocaleString()}</td>
                                <td style={{...styles.td, color: '#c62828'}}>{parseFloat(d.remaining_amount || d.amount).toLocaleString()}</td>
                                <td style={styles.td}>{d.currency}</td>
                                <td style={styles.td}>{d.status === 'paid' ? '✅ مسدد' : d.status === 'partial' ? '⚡ جزئي' : '⏳ معلق'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {customerReport.transactions.length > 0 && (
                    <div style={styles.section}>
                      <h4 style={styles.sectionTitle}>📒 عمليات الحساب ({customerReport.transactions.length})</h4>
                      <div style={styles.tableCard}>
                        <table style={styles.table}>
                          <thead><tr style={styles.tableHead}><th style={styles.th}>الرقم المرجعي</th><th style={styles.th}>النوع</th><th style={styles.th}>المبلغ</th><th style={styles.th}>العملة</th><th style={styles.th}>الرصيد بعد</th><th style={styles.th}>التاريخ</th></tr></thead>
                          <tbody>
                            {customerReport.transactions.map((t, i) => (
                              <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                                <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{t.reference_number}</td>
                                <td style={styles.td}>{t.type}</td>
                                <td style={{...styles.td, color: ['receive','sell','transfer_in'].includes(t.type) ? '#2e7d32' : '#c62828', fontWeight: 'bold'}}>
                                  {['receive','sell','transfer_in'].includes(t.type) ? '+' : '-'}{parseFloat(t.amount).toLocaleString()}
                                </td>
                                <td style={styles.td}>{t.currency_code}</td>
                                <td style={styles.td}>{parseFloat(t.balance_after || 0).toLocaleString()}</td>
                                <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(t.created_at)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  reportInfo: { display: 'flex', gap: '10px', alignItems: 'center' },
  reportUser: { background: '#e3f2fd', color: '#1a237e', padding: '6px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold' },
  reportDate: { background: '#f5f5f5', color: '#666', padding: '6px 12px', borderRadius: '20px', fontSize: '13px' },
  printBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  printBtn2: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  tabs: { display: 'flex', gap: '8px', marginBottom: '25px', flexWrap: 'wrap' },
  tabBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#666' },
  tabActive: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '25px' },
  statCard: { borderRadius: '12px', padding: '25px', color: 'white', textAlign: 'center' },
  statIcon: { fontSize: '30px', marginBottom: '10px' },
  statNumber: { fontSize: '32px', fontWeight: 'bold', marginBottom: '5px' },
  statLabel: { fontSize: '14px', opacity: 0.9 },
  reportCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '25px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  reportHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  reportActions: { display: 'flex', gap: '10px', alignItems: 'center' },
  reportTitle: { color: '#1a237e', fontSize: '18px', marginBottom: '0' },
  dateInput: { padding: '8px 12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px' },
  pdfBtn: { background: 'linear-gradient(135deg, #c62828, #b71c1c)', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  dailyGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' },
  dailyCard: { background: '#f8f9fa', borderRadius: '12px', padding: '20px' },
  dailyTitle: { color: '#1a237e', marginBottom: '15px', fontSize: '16px' },
  dailyStat: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px', fontSize: '14px', color: '#666' },
  dailyValue: { fontWeight: 'bold', color: '#333' },
  treasuryGrid: { display: 'flex', gap: '20px', flexWrap: 'wrap' },
  treasuryItem: { background: '#e3f2fd', borderRadius: '12px', padding: '20px 30px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', minWidth: '130px' },
  tCurrency: { fontSize: '20px', fontWeight: 'bold', color: '#1a237e' },
  tBalance: { fontWeight: 'bold', color: '#333', wordBreak: 'break-all', textAlign: 'center' },
  summaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '15px', marginBottom: '20px' },
  summaryItem: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', display: 'flex', flexDirection: 'column', gap: '8px' },
  summaryLabel: { fontSize: '13px', color: '#666' },
  summaryValue: { fontSize: '22px', fontWeight: 'bold', color: '#1a237e' },
  periodRow: { display: 'flex', gap: '8px', marginBottom: '15px', flexWrap: 'wrap' },
  periodBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  periodActive: { background: '#1a237e', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  dateRow: { display: 'flex', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' },
  filterLabel: { display: 'block', fontSize: '12px', color: '#666', marginBottom: '4px', fontWeight: 'bold' },
  fetchBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '10px 25px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', marginBottom: '20px' },
  customerSelectRow: { display: 'flex', gap: '15px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' },
  selectInput: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  customerInfoCard: { background: '#f8f9fa', borderRadius: '12px', padding: '20px', marginBottom: '20px' },
  customerInfoRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '15px' },
  customerInfoName: { color: '#1a237e', fontSize: '20px', marginBottom: '8px' },
  customerInfoDetail: { color: '#666', fontSize: '13px', margin: '3px 0' },
  customerSummaryBoxes: { display: 'flex', gap: '15px', flexWrap: 'wrap' },
  summaryBox: { background: 'white', borderRadius: '10px', padding: '15px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  summaryBoxLabel: { display: 'block', fontSize: '12px', color: '#666', marginBottom: '5px' },
  summaryBoxValue: { display: 'block', fontSize: '22px', fontWeight: 'bold', color: '#1a237e' },
  section: { marginBottom: '20px' },
  sectionTitle: { color: '#1a237e', fontSize: '16px', marginBottom: '10px', borderBottom: '2px solid #e3f2fd', paddingBottom: '8px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '10px 12px', color: 'white', textAlign: 'right', fontSize: '12px', whiteSpace: 'nowrap' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '8px 12px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  empty: { textAlign: 'center', padding: '30px', color: '#999' },
};

export default Reports;